"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var layout_service_1 = require("./layout-service");

var axios_fetcher_1 = require("../axios-fetcher");

var data_fetcher_1 = require("../data-fetcher");

var debug_1 = __importDefault(require("../debug"));
/**
 * Resolves layout service url
 * @param {LayoutServiceConfig} [options] layout service options
 * @param {string} apiType which layout service API to call ('render' or 'placeholder')
 * @returns the layout service url
 */


function resolveLayoutServiceUrl(options, apiType) {
  if (options === void 0) {
    options = {};
  }

  var _a = options.host,
      host = _a === void 0 ? '' : _a,
      _b = options.configurationName,
      configurationName = _b === void 0 ? 'jss' : _b,
      serviceUrl = options.serviceUrl;

  if (serviceUrl) {
    return serviceUrl;
  }

  return host + "/sitecore/api/layout/" + apiType + "/" + configurationName;
}

exports.resolveLayoutServiceUrl = resolveLayoutServiceUrl;
/**
 * Makes a request to Sitecore Layout Service for the specified route item path.
 * @deprecated Will be removed in a future release. Please use LayoutService.fetchLayoutData instead,
 * @see {LayoutService} - fetchLayoutData
 * @param {string} itemPath
 * @param {LayoutServiceRequestOptions<LayoutServiceData>} options
 * @returns {Promise<LayoutServiceData>} layout data
 */

function fetchRouteData(itemPath, options) {
  var querystringParams = options.querystringParams,
      layoutServiceConfig = options.layoutServiceConfig;
  var fetchUrl = resolveLayoutServiceUrl(layoutServiceConfig, 'render');
  return data_fetcher_1.fetchData(fetchUrl, options.fetcher, __assign({
    item: itemPath
  }, querystringParams));
}

exports.fetchRouteData = fetchRouteData;
/**
 * Makes a request to Sitecore Layout Service for the specified placeholder in
 * a specific route item. Allows you to retrieve rendered data for individual placeholders instead of entire routes.
 * @deprecated Will be removed in a future release. Please use LayoutService.fetchPlaceholderData instead,
 * @see {LayoutService} - fetchPlaceholderData
 * @param {string} placeholderName
 * @param {string} itemPath
 * @param {LayoutServiceRequestOptions<PlaceholderData>} options
 * @returns {Promise<PlaceholderData>} placeholder data
 */

function fetchPlaceholderData(placeholderName, itemPath, options) {
  var querystringParams = options.querystringParams,
      layoutServiceConfig = options.layoutServiceConfig;
  var fetchUrl = resolveLayoutServiceUrl(layoutServiceConfig, 'placeholder');
  return data_fetcher_1.fetchData(fetchUrl, options.fetcher, __assign({
    placeholderName: placeholderName,
    item: itemPath
  }, querystringParams));
}

exports.fetchPlaceholderData = fetchPlaceholderData;
/**
 * Fetch layout data using the Sitecore Layout Service REST API.
 * Uses Axios as the default data fetcher (@see AxiosDataFetcher).
 */

var RestLayoutService =
/** @class */
function (_super) {
  __extends(RestLayoutService, _super);

  function RestLayoutService(serviceConfig) {
    var _this = _super.call(this) || this;

    _this.serviceConfig = serviceConfig;
    /**
     * Provides fetch options in order to fetch data
     * @param {string} [language] language will be applied to `sc_lang` param
     * @returns {FetchOptions} fetch options
     */

    _this.getFetchOptions = function (language) {
      var _a;

      var params = {
        sc_apikey: _this.serviceConfig.apiKey,
        sc_site: _this.serviceConfig.siteName,
        sc_lang: language || '',
        tracking: (_a = _this.serviceConfig.tracking, _a !== null && _a !== void 0 ? _a : true)
      };
      return {
        layoutServiceConfig: {
          host: _this.serviceConfig.apiHost,
          configurationName: _this.serviceConfig.configurationName
        },
        querystringParams: __assign({}, params)
      };
    };
    /**
     * Provides default @see AxiosDataFetcher data fetcher
     * @param {IncomingMessage} [req] Request instance
     * @param {ServerResponse} [res] Response instance
     * @returns default fetcher
     */


    _this.getDefaultFetcher = function (req, res) {
      var config = {
        debugger: debug_1.default.layout
      };

      if (req && res) {
        config.onReq = _this.setupReqHeaders(req);
        config.onRes = _this.setupResHeaders(res);
      }

      var axiosFetcher = new axios_fetcher_1.AxiosDataFetcher(config);

      var fetcher = function fetcher(url, data) {
        return axiosFetcher.fetch(url, data);
      };

      return fetcher;
    };

    return _this;
  }
  /**
   * Fetch layout data for an item.
   * @param {string} itemPath
   * @param {string} [language]
   * @param {IncomingMessage} [req] Request instance
   * @param {ServerResponse} [res] Response instance
   * @returns {Promise<LayoutServiceData>} layout service data
   */


  RestLayoutService.prototype.fetchLayoutData = function (itemPath, language, req, res) {
    var fetchOptions = this.getFetchOptions(language);
    debug_1.default.layout('fetching layout data for %s %s %s', itemPath, language, this.serviceConfig.siteName);
    var fetcher = this.serviceConfig.dataFetcherResolver ? this.serviceConfig.dataFetcherResolver(req, res) : this.getDefaultFetcher(req, res);
    return fetchRouteData(itemPath, __assign({
      fetcher: fetcher
    }, fetchOptions)).catch(function (error) {
      var _a;

      if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
        // Aligned with response of GraphQL Layout Service in case if layout is not found.
        // When 404 Rest Layout Service returns
        // {
        //   sitecore: {
        //     context: {
        //       pageEditing: false,
        //       language
        //     },
        //     route: null
        //   },
        // }
        //
        return error.response.data;
      }

      throw error;
    });
  };
  /**
   * Fetch layout data for a particular placeholder.
   * Makes a request to Sitecore Layout Service for the specified placeholder in
   * a specific route item. Allows you to retrieve rendered data for individual placeholders instead of entire routes.
   * @param {string} placeholderName
   * @param {string} itemPath
   * @param {string} [language]
   * @param {IncomingMessage} [req] Request instance
   * @param {ServerResponse} [res] Response instance
   * @returns {Promise<PlaceholderData>} placeholder data
   */


  RestLayoutService.prototype.fetchPlaceholderData = function (placeholderName, itemPath, language, req, res) {
    var fetchOptions = this.getFetchOptions(language);
    debug_1.default.layout('fetching placeholder data for %s %s %s %s', placeholderName, itemPath, language, this.serviceConfig.siteName);
    var fetcher = this.serviceConfig.dataFetcherResolver ? this.serviceConfig.dataFetcherResolver(req, res) : this.getDefaultFetcher(req, res);
    return fetchPlaceholderData(placeholderName, itemPath, __assign({
      fetcher: fetcher
    }, fetchOptions));
  };
  /**
   * Setup request headers
   * @param {IncomingMessage} req
   * @returns {AxiosRequestConfig} axios request config
   */


  RestLayoutService.prototype.setupReqHeaders = function (req) {
    return function (reqConfig) {
      debug_1.default.layout('performing request header passing');
      reqConfig.headers.common = __assign(__assign(__assign(__assign(__assign({}, reqConfig.headers.common), req.headers.cookie && {
        cookie: req.headers.cookie
      }), req.headers.referer && {
        referer: req.headers.referer
      }), req.headers['user-agent'] && {
        'user-agent': req.headers['user-agent']
      }), req.connection.remoteAddress && {
        'X-Forwarded-For': req.connection.remoteAddress
      });
      return reqConfig;
    };
  };
  /**
   * Setup response headers based on response from layout service
   * @param {ServerResponse} res
   * @returns {AxiosResponse} response
   */


  RestLayoutService.prototype.setupResHeaders = function (res) {
    return function (serverRes) {
      debug_1.default.layout('performing response header passing');
      serverRes.headers['set-cookie'] && res.setHeader('set-cookie', serverRes.headers['set-cookie']);
      return serverRes;
    };
  };

  return RestLayoutService;
}(layout_service_1.LayoutServiceBase);

exports.RestLayoutService = RestLayoutService;